import React from "react";
import PropTypes from "prop-types";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import styles from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import { InputAdornment, DialogActions } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const NewTruckDialog = props => {
  const classes = useStyles(styles);
  return (
    <Dialog
      fullScreen
      classes={{
        root: classes.center + " " + classes.modalRoot,
        paper: classes.modal
      }}
      open={props.isModalVisible}
      TransitionComponent={Transition}
      keepMounted
      onClose={props.onClose}
    >
      <DialogTitle
        id="classic-modal-slide-title"
        disableTypography
        className={classes.modalHeader}
      >
        <Button
          justIcon
          className={classes.modalCloseButton}
          key="close"
          aria-label="Close"
          color="transparent"
          onClick={props.onClose}
        >
          <Close className={classes.modalClose} />
        </Button>
        <h3 className={classes.modalTitle}>{props.title}</h3>
      </DialogTitle>
      <DialogContent
        id="classic-modal-slide-description"
        className={classes.modalBody}
      >
        <CustomInput
          id="success"
          style={{ marginTop: 20 }}
          value={props.data.plate_number}
          onChange={text =>
            props.onDataChanged("plate_number", text.toUpperCase())
          }
          labelText="Plate Number"
          helperText={
            props.plateNumberState === "error" && "plate number is not valid"
          }
          success={props.plateNumberState === "success"}
          error={props.plateNumberState === "error"}
          formControlProps={{
            fullWidth: true
          }}
        />
        <CustomInput
          id="success"
          style={{ marginTop: 20 }}
          value={props.data.brand ? props.data.brand : ""}
          onChange={text => props.onDataChanged("brand", text)}
          labelText="Brand (Optional)"
          formControlProps={{
            fullWidth: true
          }}
        />
        <CustomInput
          id="success"
          style={{ marginTop: 20 }}
          value={props.data.color ? props.data.color : ""}
          onChange={text => props.onDataChanged("color", text)}
          labelText="Color (Optional)"
          formControlProps={{
            fullWidth: true
          }}
        />
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button
          onClick={props.onClose}
          variant="contained"
          color="primary"
          simple
        >
          Close
        </Button>
        {props.saving ? (
          <CircularProgress
            size={30}
            color="primary"
            style={{ marginRight: 30 }}
          />
        ) : (
          <Button onClick={props.onSubmit} color="primary" variant="contained">
            Save
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
export default NewTruckDialog;

NewTruckDialog.prototype = {
  isModalVisible: PropTypes.bool
};
